// extracted by mini-css-extract-plugin
export default {"subtitle":"styles_subtitle__zf7CM","buttons":"styles_buttons__Bignj"};